<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData"   :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="id"  @change="handleTableChange">
            <template slot="operation" slot-scope="text, record">
                <router-link class="tableLink" :to="{path:'detailsignmanager',query: {id: record.id,}}">详情</router-link>
                <router-link class="tableLink"  :to="{path:'editsignmanager',query: {id: record.id,}}">编辑</router-link>
                <a class="tableLink"  href="javascript:;" @click="handleQuery(record)">查询结果</a>
                <a-popconfirm title="确认删除?" @confirm="() => handleDelete(record)">
                    <a class="tableLink"  href="javascript:;">删除</a>
                </a-popconfirm>
            </template>
            <template slot="signTypes" slot-scope="text">
                <span >{{ signTypes[text] }}</span>
            </template>
            <template slot="signStatuNames" slot-scope="text">
                <span >{{ signStatuNames[text] }}</span>
            </template>
            <template slot="applytypeNames" slot-scope="text">
                <span >{{ applytypeNames[text] }}</span>
            </template>
            
        </a-table>
        <a-pagination style="float:right;margin-top:20px;" v-model="pagination.page" :pageSize="pagination.pageSize"
            :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper />

    </div>
</template>
<script>
let pagination ={
    page:1,
    pageSize:10,
    total:0
};

const signTypes = {
    '1':'商户签名',
    '2':'服务商签名',
}

const signStatuNames = {
    '0':'审核中',
    '1':'审核通过',
    '2':'审核失败'
}

const applytypeNames = {
    '0' : '否',
    '1' : '是'
}


const columns = [
    {
        title: "序号",
        width: 50,
        align: "center",
        customRender: (text, record, index) => {
            let { page, pageSize } = pagination;
            return (Number(page) - 1) * Number(pageSize) + index + 1;
        }
    },
    {
        title: "商户编码",
        dataIndex: "applyusercode",
        align: "center",
        scopedSlots: { customRender: 'domainNames' },
        width:100
    },
    {
        title: "商户名称",
        dataIndex: "applyusername",
        align: "center",
        width:300,
        ellipsis: true,
    },
    
    // {
    //     title: "签名编码",
    //     dataIndex: "signcode",
    //     align: "center",
    //     width:100,
    //     ellipsis: true,
    // },
    {
        title: "申请平台",
        dataIndex: "plateorigin",
        align: "center",
        width:100,
        ellipsis: true,
    },
    {
        title: "作用域",
        dataIndex: "signtype",
        align: "center",
        scopedSlots:{ customRender:'signTypes' },
        width:100,
        ellipsis: true,
    },
    {
        title: "审核状态",
        dataIndex: "signstatus",
        scopedSlots:{ customRender:'signStatuNames'},
        align: "center",
        width:100,
        ellipsis: true,
    },
    {
        title: "签名名称",
        dataIndex: "signname",
        align: "center",
        width:200,
        ellipsis: true,
    },

    {
        title: "签名来源名称",
        dataIndex: "signoriginname",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: "三证合一",
        dataIndex: "applytype",
        scopedSlots:{ customRender:'applytypeNames' },
        align: "center",
        width:80,
        ellipsis: true,
    },
    // {
    //     title: "申请签名照片",
    //     dataIndex: "applypics",
    //     align: "center",
    //     width:200,
    //     ellipsis: true,
    // },
    {
        title: "申请说明",
        dataIndex: "remark",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: "驳回原因",
        dataIndex: "reason",
        align: "center",
        width:200,
        ellipsis: true,
    },
    {
        title: "审核时间",
        dataIndex: "applytime",
        align: "center",
        width:150,
        ellipsis: true,
    },
    {
        title: "阿里云返回的请求id",
        dataIndex: "requestid",
        align: "center",
        width:150,
        ellipsis: true,
    },
    {
        title: "创建时间",
        dataIndex: "createtime",
        align: "center",
        width:150,
        ellipsis: true,
    },

    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        width: 200,
        scopedSlots: { customRender: 'operation' },
    }

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            pagination,
            clientWidth:800,
            ordercoloum:'total',
            orderstr:'desc',
            searchP:{},
            platforms:[],
            signTypes,
            signStatuNames,
            applytypeNames,
        };
    },
    methods: {
        handleTableChange(d,v,sorter) {
            if(sorter.order){
                this.ordercoloum = sorter.field ;
                this.orderstr = sorter.order.replace('end','');
            }
            else{
                this.ordercoloum = '';
                this.orderstr = '';
            }

            this.getAppSumData();
        },
        handlePageChange(v){
            this.pagination.page = v
            this.getAppSumData();
        },
        handleQuery(item){
            let that = this;
            that.$store.dispatch({
                type: "wxtemplatemanager/querySmsSignApplyStatus",
                params: {
                    id: item.id
                }
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        handleDelete(item){
            let that = this;
            that.$store.dispatch({
                type: "wxtemplatemanager/deleteSmsSignApply",
                params: {
                    id: item.id
                }
            }).then((res) => {
                if (res.status == '200') {
                    that.pagination.page = 1;
                    that.getAppSumData()
                }
            });
            
        },
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: "wxtemplatemanager/querySmsSignApplyPageList",
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    this.tableData = result.list;
                    this.pagination.total = parseInt(result.totalRecords);
                    this.pagination.pageSize = parseInt(result.pageSize);
                    this.pagination.page = parseInt(result.page);
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.pagination.page = 1;
            this.getAppSumData();
        },
    },

    components:{
        
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

